export const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  menu: (base) => ({ ...base, zIndex: 9999 }),
  control: (base, state) => ({
    ...base,
    minHeight: "40px",
    borderRadius: "var(--border-radius, 10px)",
    borderColor: state.isFocused ? "var(--topbar-color, #233064)" : "var(--border-color, #dee2e6)",
    boxShadow: state.isFocused ? "0 0 0 1px var(--topbar-color, #233064)" : "none",
    fontSize: "14px",
    fontFamily: "var(--font-family, 'Segoe UI', sans-serif)",
    "&:hover": {
      borderColor: "var(--topbar-color, #233064)",
    },
  }),
  singleValue: (base) => ({
    ...base,
    color: "var(--text-primary, #1d1d1d)",
  }),
  indicatorSeparator: (base) => ({
    ...base,
    backgroundColor: "var(--border-color, #dee2e6)",
  }),
  option: (base, { isFocused, isSelected }) => ({
    ...base,
    backgroundColor: isSelected
      ? "var(--topbar-color, #233064)"
      : isFocused
      ? "rgba(35,48,100,0.1)"
      : "transparent",
    color: isSelected ? "#ffffff" : "var(--text-primary, #1d1d1d)",
  }),
};